import React, { Component } from 'react';
import { isEmpty } from 'lodash'
import Dialog from '../../../../commonModules/interface/Dialog.jsx';
import SingleProduct from '../products/SingleProduct.jsx';
import Notif from '../../../../commonModules/interface/Notif.jsx';
import { connect } from 'react-redux';
import { BreadCrumb, ListLayout, TableLayout } from '../containers/Layout';
import SingleShop from '../shops/SingleShop.jsx';
import { TableRow, TableCell, Button, TableHead, TableBody, Typography, TextField, AppBar, Tabs, Tab, Box, Card, IconButton, Grid, TablePagination } from '@material-ui/core';
import { AutorenewRounded, RefreshRounded, StorageRounded,CloudDownload } from '@material-ui/icons';
import { fetchStocks } from '../../../../../../../jsx/actions/inventoryAction';
import { bindActionCreators } from 'redux';
import { amber, blue, blueGrey, cyan, green, indigo, purple, red, yellow } from '@material-ui/core/colors';
import InputText, { InputSelectNative } from '../../../../commonModules/interface/form-input-inline.jsx';
import AccordionFilter from '../Filter/AccordionFilter.jsx';
import SingleHistory from '../transfers/stocks/SingleHistory.jsx';
import SingleHistoryToggle from '../transfers/stocks/SingleHistoryToggle.jsx';
import { toast } from 'react-toastify';

const translate = {
    "new": "Comme Neuf",
    "very_good": "Très bien",
    "good": "Bien",
    "bad": "Mauvais",
}

class StockList extends Component {
    state = {
        tabHistory:1,
        search:"",
        searchGroup:{
            searchName: "",
            searchMarque: "",
            searchType: "",
            searchRef: "",
            
        },        //Dialog
        dialogHistory: false,
        dialogNew: false,
        // stockList: "AVAILABLE",
        stockList: this.props.occasion ? "OCCASION" : "AVAILABLE",

        //stock, used for history
        history_single:{
            product_id: "",
            shop_id: ""
        },
        singleProd:{},
        singleShop:{},

        breadcrumb: "",
        showSingle: false,
        
        sortQty:"",
        
        // Pagination
        page: 0,
        rowsPerPage: 10,
    }
    normalizeStr = (str) => {// remove accent and lower case str
        str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
        return str
    }
    handleSearch = (e) => {
        const { name, value } = e.target
        let newSearch = Object.assign({}, this.state.searchGroup)
        newSearch[name] = value

        this.setState({
            ...this.state,
            searchGroup: newSearch,
        })     
        // this.filterList(newSearch)       
    }
    
    createTypeList = () => { 
        const types = {
            "panneaux":"Panneaux Solaires",
            "regulateurs":"Régulateurs",
            "convertisseurs":"Convertisseurs",
            "convertisseurs_chargeurs":"Convertisseur-Chargeurs",
            "convertisseurs_chargeurs_MPPT":"Convertisseur-Chargeurs - MPPT",
            "convertisseurs_dc-dc":"Convertisseur DC-DC",
            "batteries":"Batteries",
            "cables":"Câbles",
            "lampes":"Lampes",
            "supervision":"Supervision",
            "kit":"Kits complet",
            "menager":"Equipement ménager",
            "pompes":"Pompes",
            "picos":"Picos",
            "accesoires":"Accessoires",
            "protection":"Protection",
            "autres":"Autres"
        }
        return Object.keys(types).map((key) => {
            return (        
                <option key={key} value={key} >{types[key]}</option>
            )
        })
    }

    filterSearchBar = () => {
        const { SHOPS, PRODUCTS, STOCKS } = this.props
        const { stockList, search, sortQty } = this.state

        let searching = search ? this.normalizeStr(search) : ""
        let list = STOCKS && STOCKS[stockList] ? Object.keys(STOCKS[stockList]) : []
        if (this.props.where && STOCKS && STOCKS[stockList]){
            list = list.filter(stock => (STOCKS[stockList][stock] && STOCKS[stockList][stock][this.props.where] === this.props.filter ))
            // console.log('====================================');
            // console.log({list});
            // console.log('====================================');
        } 

        let filteredList = list.filter( stockID => {
            const stock = STOCKS && STOCKS[stockList] ? STOCKS[stockList][stockID] : null
            if (!stock) return false;
            
            let product = PRODUCTS && stock.product_id ? PRODUCTS[stock.product_id] : null
            let shop = SHOPS && stock.shop_id ? SHOPS[stock.shop_id] : null

            if(!searching){
                return true
            } else {
                const productName = product ? this.normalizeStr(product.name) : ""
                const productRef = product ? this.normalizeStr(product.ref) : ""
                const productType = product ? this.normalizeStr(product.product_type) : ""
                const productBrand = product ? this.normalizeStr(product.marque) : ""
                const shopName = shop ? this.normalizeStr(shop.name) : ""
                const shopCity = shop ? this.normalizeStr(shop.city) : ""
                const shopCountry = shop ? this.normalizeStr(shop.country) : ""
                return ( 
                    
                    productName.indexOf(searching) !== -1 ||
                    productRef.indexOf(searching) !== -1 ||
                    productType.indexOf(searching) !== -1 ||
                    productBrand.indexOf(searching) !== -1 ||
                    shopName.indexOf(searching) !== -1 ||
                    shopCity.indexOf(searching) !== -1 ||
                    shopCountry.indexOf(searching) !== -1 
                )
            }
        })
        console.log({filteredList}, filteredList.length);

        // sort
        if( sortQty === 'asc' && STOCKS && STOCKS[stockList] ){
            filteredList.sort( (stock1, stock2) => {
                const stock1Data = STOCKS[stockList][stock1];
                const stock2Data = STOCKS[stockList][stock2];
                return (stock1Data && stock2Data) ? stock1Data.quantity - stock2Data.quantity : 0;
            })
        } else if ( sortQty === 'desc' && STOCKS && STOCKS[stockList] ) {
            filteredList.sort( (stock1, stock2) => {
                const stock1Data = STOCKS[stockList][stock1];
                const stock2Data = STOCKS[stockList][stock2];
                return (stock1Data && stock2Data) ? stock2Data.quantity - stock1Data.quantity : 0;
            })
        }
        return filteredList
    }

    filterList = (search = this.state.searchGroup) => {
        // console.log("start filter List");
        const { PRODUCTS, STOCKS } = this.props
        const { searchName, searchMarque, searchType, searchRef } = search;
        const { stockList } = this.state

        let filteredList = this.filterSearchBar()
        let newList = []

        if (isEmpty(searchName)  &&
        isEmpty(searchMarque) &&
        isEmpty(searchType) &&
        isEmpty(searchRef) ) {
            return filteredList
        }
        const vName = this.normalizeStr(searchName)
        const vMarque = this.normalizeStr(searchMarque)
        const vType = this.normalizeStr(searchType)
        const vRef = this.normalizeStr(searchRef)

        filteredList.forEach( stockID => {
            const stock = STOCKS && STOCKS[stockList] ? STOCKS[stockList][stockID] : null
            if (!stock) return;
            
            let prodID = stock.product_id
            let product = PRODUCTS && prodID ? PRODUCTS[prodID] : null
            let match = false
            if (!isEmpty(searchName)  && product && this.normalizeStr(product.name).includes(vName) ) {
                match = true
            }
            if (!isEmpty(searchMarque) && product && this.normalizeStr(product.marque).includes(vMarque)) {
                match = true
            }
            if (!isEmpty(searchType) && product && product.product_type === vType) {
                match = true
            }
            if (!isEmpty(searchRef) && product && this.normalizeStr(product.ref).includes(vRef)) {
                match = true
            }
            if (match) {
                newList.push(stockID)
            }
        })

        // console.log({newList}, newList.length);
        // this.setState({
        //     filteredList: newList
        // })
        return newList
    }
    extractStock() {
        toast.error("FUNCTION NOT YET AVAILABLE")
    }
    // LISTS & TABLES
    createStockList(){
        const { SHOPS, PRODUCTS, STOCKS, RETURNS } = this.props
        const { stockList, page, rowsPerPage } = this.state

        let filteredList = this.filterList()
        
        // Apply pagination
        const startIndex = page * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;
        const paginatedList = filteredList.slice(startIndex, endIndex);

        return paginatedList.map( stockID => {
            const stock = STOCKS[stockList][stockID]
            const product = PRODUCTS[stock.product_id] || PRODUCTS[stock.product_ref] // for occasion prod
            const returnProd = RETURNS && RETURNS[stockID]// for occasion prod
            const shop = SHOPS[stock.shop_id]
            
            if( stock.quantity !== 0 && product ){      
                let prodName = product.name
                let prodShortName = (prodName.length > 40 ? (prodName.substring(0, 40) + "...") : prodName)
                return (        
                    <TableRow key={stock.id} hover >
                        <TableCell>
                            <a href="#" 
                            onClick={ () => this.handleSingleProd(product) } 
                            title={prodName}
                            >
                                {prodShortName} - {product.marque}
                            </a>
                        </TableCell>
                        {this.props.where !== "shop_id" &&
                        <TableCell>
                            <a href="#" onClick={ () => this.handleSingleShop(shop) }>
                                {shop && shop.name}
                            </a>
                        </TableCell>
                        }
                        {this.state.stockList === "OCCASION" && 
                            <TableCell>{returnProd && translate[returnProd.product_state]}</TableCell> 
                        }
                        <TableCell>{stock.quantity}</TableCell>
                        <TableCell>
                            {stockList !== "OCCASION" &&
                            stockList !== "RECTIF" &&
                                <Button color="secondary" onClick={
                                    () => this.setState({
                                        dialogHistory:true,
                                        stockID: stock.id,
                                        history_single:{
                                            name: product.name,
                                            product_id: stock.product_id || stock.product_ref, 
                                            shop_id: stock.shop_id
                                            }
                                        })
                                    }
                                >
                                    <StorageRounded />
                                </Button>
                            }
                        </TableCell>
                    </TableRow>
                )
            }
        })
    }
    
    // findHistory = () => {
    //     const { PURCHASES, SALES, COMMERCIAL_REAS, CLIENTS, COMMERCIAL_RETURNS, AGENTS, RESERVATIONS, INSTALLS, DEMANDS, ARRIVAGES } = this.props // + reappro
    //     const { history_single, stockList } = this.state;
    //     let found = false;
    //     let history = []
    //     let ALL = Object.assign({}, PURCHASES, SALES, COMMERCIAL_REAS, COMMERCIAL_RETURNS, RESERVATIONS, INSTALLS )
    //     let opList = Object.values(ALL)

    //     opList = opList.filter(OP => history_single.shop_id === OP.shop_id )
    //     opList.sort((OP1, OP2) => new Date(OP2.date) - new Date(OP1.date) )

    //     if(stockList === "LEASING"){
    //         opList = opList.filter(OP => OP.nature === "payg" )

    //     } else if(stockList === "COMMERCIAL"){
    //         opList = opList.filter(OP => OP.nature === "commercial" )

    //     } else if(stockList === "WAITING_DELIVERY"){
    //         opList = opList.filter(OP =>  {
    //             if (PURCHASES[OP.id]){
    //                 return !PURCHASES[OP.id].received
    //             }
    //         } )

    //     } else if(stockList === "RESERVATION"){
    //         opList = Object.values(RESERVATIONS)
            
    //     } else if(stockList === "INSTALLATION"){
    //         opList = Object.values(INSTALLS)

    //     } else if(stockList === "DEMAND"){
    //         opList = Object.values(DEMANDS)

    //     } else if(stockList === "ARRIVAGE"){
    //         opList = Object.values(ARRIVAGES)

    //     } else if(stockList === "AVAILABLE"){
    //         opList = opList.filter(OP =>  {
    //             if (PURCHASES[OP.id] && !PURCHASES[OP.id].received){
    //                 return false
    //             }
    //             return true
    //         } )
    //         // opList.concat(opList.filter(OP => OP.nature === "rectif" ))
    //     }
    //     if(opList.length > 0){
    //         opList.map( OP => {

    //             OP.products.map( prod => {
    //                 if( history_single.product_id === prod.product_id && 
    //                     OP.nature !== "devis" 
    //                 ){ // single { product_id, shop_id}
                    
    //                     found = true
    //                     prod.id = OP.id
    //                     prod.date = OP.date
    //                     let style = {
    //                         background: red[100]
    //                     }
    //                     if (OP.nature === "reapprovisionnement" ){
    //                         prod.nature = "reappro"
    //                     } else if (OP.nature === "reapprovisionnement_ext" ){
    //                         prod.nature = "reappro_ext"
    //                     } else if (OP.nature === "rectif" ){
    //                         prod.nature = "retour_com"
    //                     } else {
    //                         prod.nature = OP.nature
    //                     }

    //                     prod.prix_revient = (prod.price * OP.surcout || prod.price)
                        
    //                     if (OP.type === "resa"){
    //                         style.background = purple[100]
    //                         prod.nature = "reservation"
    //                     } else if (OP.type === "install"){
    //                         style.background = amber[100]
    //                         prod.nature = "installation"
    //                     } else if (OP.type === "arrivage"){
    //                         style.background = cyan[100]
    //                         prod.nature = "arrivage"
    //                     } else if (OP.type === "demand"){
    //                         style.background = indigo[100]
    //                         prod.nature = "demand"
    //                     } else if (OP.nature === "sav"){
    //                         style.background = blueGrey[100]
    //                     } else if (OP.nature === "payg" || OP.nature === "commercial"){
    //                         style.background = blue[100]
    //                     } else if (OP.nature === "prepa"){
    //                         style.background = yellow[100]
    //                     } else if ( OP.nature === "achat" || OP.nature === "rectif") {
    //                         style.background = green[100] // lightgreen
    //                     }

    //                     if (!!OP.surcout || OP.nature === "rectif"){
    //                         style.fontWeight = 700
    //                     }

    //                     if (!isEmpty(OP.client_ref)) {
    //                         prod.client = CLIENTS[OP.client_ref] ? CLIENTS[OP.client_ref].client_lastname : ""
    //                     } else if (!isEmpty(prod.sale_item_commercial_id)) {
    //                         prod.client = AGENTS[prod.sale_item_commercial_id] ? AGENTS[prod.sale_item_commercial_id].name : ""
    //                     } else if (!isEmpty(prod.purchase_item_com_id)) {
    //                         prod.client = AGENTS[prod.purchase_item_com_id] ? AGENTS[prod.purchase_item_com_id].name : ""
    //                     }
                                                
    //                     history.push({
    //                         entry: !!OP.surcout || OP.nature === "rectif" || OP.nature === "arrivage" || OP.nature === "demande" ,
    //                         // entry: !!OP.surcout || OP.nature === "retour_com" ,
    //                         item: prod,
    //                         style
    //                     })
    //                     // console.log("okay, op exists", prod);
    //                 }
    //             })
    //         })
            
    //         // console.log("HISTORY TABLE", history);
            
    //         return[
    //             history.map( OP => {
    //                 return (        
    //                     <TableRow style={OP.style} key={OP.item.id}>
    //                         <TableCell style={OP.style}>{(new Date(OP.item.date)).toLocaleString('fr-FR')}</TableCell>                        
    //                         <TableCell style={OP.style}>{OP.item.nature}</TableCell>
    //                         <TableCell style={OP.style}>{OP.entry ? OP.item.quantity : (OP.item.quantity * -1) }</TableCell>
    //                         <TableCell style={OP.style}>{OP.item.client}</TableCell>
    //                         <TableCell style={OP.style}>{OP.entry ? Math.round(OP.item.prix_revient).toLocaleString("fr-FR") : ""}</TableCell>
    //                     </TableRow>
    //                 )
    //             }),
    //             found
    //         ]
    //     } else {
    //         return ["", false]
    //     }
    // }
      
// CLEAR & DISPLAY
    handleClose = () => {
        this.setState({
            dialogHistory:false,
            dialogNew:false,
            showSingleProd: false,
            showSingleShop: false,
            breadcrumb: "",
            history_single:{
                name:"",
                product_id:"",
                shop_id:"",
            }
        });
    }
    handleSingleProd = (prod) => {
        this.setState({
            breadcrumb: prod.name,
            singleProd:prod,
            showSingleProd: true
        })
    }
    handleSingleShop = (shop) => {
        this.setState({
            breadcrumb: shop.name,
            singleShop:shop,
            showSingleShop: true
        })

    }
    
    // Pagination handlers
    handleChangePage = (event, newPage) => {
        this.setState({
            page: newPage
        });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        });
    };
    
    // Reset page when stock list changes
    componentDidUpdate(prevProps, prevState) {
        // Reset page when switching tabs or when data changes
        if (prevState.stockList !== this.state.stockList || 
            prevState.searchGroup !== this.state.searchGroup ||
            prevState.sortQty !== this.state.sortQty) {
            
            const totalCount = this.getTotalCount();
            const maxPage = Math.max(0, Math.ceil(totalCount / this.state.rowsPerPage) - 1);
            
            if (this.state.page > maxPage) {
                this.setState({ page: 0 });
            }
        }
    }
    
    // Get total count for pagination
    getTotalCount = () => {
        const filteredList = this.filterList();
        return filteredList.length;
    };
    
    // Validate and correct page number
    getValidPage = () => {
        const totalCount = this.getTotalCount();
        const maxPage = Math.max(0, Math.ceil(totalCount / this.state.rowsPerPage) - 1);
        return Math.min(this.state.page, maxPage);
    };
    render() {
        // console.log("[STATE] stocks ",this.state);
        // console.log("[props] stocks ",this.props);

        const { STOCKS } = this.props
        
        // const historyTable = (// DISPLAY STOCKS VARIATIONS INFOS
        //     <div>
        //         {(STOCKS[this.state.stockList] && this.state.history_single.product_id) ? (
        //             <TableLayout>
        //                     <TableHead>
        //                         <TableRow>
        //                             <TableCell>Date</TableCell>
        //                             <TableCell>Nature</TableCell>
        //                             <TableCell>Quantité</TableCell>
        //                             <TableCell>Client / Commercial</TableCell>
        //                             <TableCell>Prix</TableCell>
                                    
        //                         </TableRow>
        //                     </TableHead>
        //                     <TableBody>
        //                         {/* {this.findHistory()[0]} */}
        //                         <SingleHistory stockID={this.state.stockID} />
        //                     </TableBody>
        //             </TableLayout>
        //         ) : (
        //             <div>
        //                 <Typography variant="button">Pas de stock disponible</Typography>
        //             </div>

        //         ) }
        //     </div>
        // )
        
        return (
            <div>
                <BreadCrumb breadcrumb={ this.state.breadcrumb } title="Inventaire" back={this.handleClose} />
                {this.state.dialogHistory &&
                    <Dialog 
                        maxWidth="md"
                        block={this.state.dialogHistory}
                        title={this.state.history_single.name}
                        // text={ <SingleHistory stockID={this.state.stockID} /> }
                        text={ <SingleHistoryToggle stockID={this.state.stockID + "|" + this.state.history_single.shop_id} defaultEnhanced={true} /> }
                        close={this.handleClose}
                    />
                }
                
                {this.state.showSingleShop &&
                    <SingleShop shop={this.state.singleShop} {...this.props} />    
                }       
                {this.state.showSingleProd &&
                    <SingleProduct product={this.state.singleProd} stocks={ STOCKS[this.state.stockList]} shops={ this.props.SHOPS} {...this.props} />
                }
                {!this.state.showSingleShop && !this.state.showSingleProd &&
                    <Box >
                        <Box p={2} style={{textAlign: "right"}}>
                            <Button variant="contained" color="secondary" startIcon={<AutorenewRounded />} onClick={this.props.fetchStocks}>
                                Reload
                            </Button>   
                            <Button variant="contained" color="primary" startIcon={<CloudDownload />} onClick={this.extractStock}>
                                Export
                            </Button>
                        </Box>

                        <AccordionFilter title="Recherche">
                            {/* <Box p={2}> */}
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <InputText type="text" id="searchRef" onChange={this.handleSearch} value={this.state.searchGroup.searchRef} name="searchRef" title="Réference du produit"/>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <InputText type="text" id="searchName" onChange={this.handleSearch} value={this.state.searchGroup.searchName} name="searchName" title="Nom du produit"/>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <InputText type="text" id="searchMarque" onChange={this.handleSearch} value={this.state.searchGroup.searchMarque} name="searchMarque" title="Marque du produit"/>                                            
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <InputSelectNative
                                            id="searchType" 
                                            onChange={this.handleSearch} 
                                            value={this.state.searchGroup.searchType} 
                                            name="searchType" 
                                            title="Type" 
                                            options={this.createTypeList()}
                                            labelWidth={60}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InputText 
                                            name="search" 
                                            title="Autre"
                                            value={this.state.search} 
                                            placeholder="Rechercher par magasin, produit, marque ..." 
                                            onChange={ (e) => this.setState({search: e.target.value})} 
                                        />
                                    </Grid>
                                </Grid>
                            {/* </Box>                                                    */}
                        </AccordionFilter>

                        <Card>
                            <AppBar position="static">
                                <Tabs
                                    value={this.state.stockList}
                                    onChange={(e, tab) => this.setState({ stockList: tab})}
                                    indicatorColor="secondary"
                                    textColor="secondary"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                >
                                    <Tab value="AVAILABLE" label="Disponible" />
                                    <Tab value="WAITING_DELIVERY" label="En transit interne" />
                                    <Tab value="COMMERCIAL" label="Remis à des commerciaux" />
                                    <Tab value="RESERVATION" label="Reservation" />
                                    {/* {this.props.STOCKS && !isEmpty(this.props.STOCKS.PREPA) &&
                                        <Tab value="PREPA" label="Reservation" />
                                    } */}
                                        <Tab value="ARRIVAGE" label="Arrivage" />
                                    
                                        <Tab value="DEMAND" label="Demande" />
                                    
                                        <Tab value="INSTALLATION" label="En cours d'installation" />
                             
                                    <Tab value="LEASING" label="Vendu en PayG" />
                                    <Tab value="OUT" label="Vendu en Cash" />
                                    <Tab value="OCCASION" label="Occasion" />
                                </Tabs>
                            </AppBar>
                            
                            <ListLayout>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Produit</TableCell>
                                        {this.props.where !== "shop_id" && 
                                            <TableCell>Shop</TableCell>
                                        }
                                        {this.state.stockList === "OCCASION" && 
                                            <TableCell>Etat</TableCell>
                                        }
                                        <TableCell 
                                            className={"sorting" + this.state.sortQty} 
                                            onClick={() => this.setState({ 
                                                sortQty: (this.state.sortQty === 'asc' || this.state.sortQty === '' ? 'desc' : 'asc' )})
                                            }
                                        >
                                            Quantité
                                        </TableCell>
                                        <TableCell>Historique</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {STOCKS && STOCKS[this.state.stockList] && Object.keys(STOCKS[this.state.stockList]).length > 0  && this.createStockList()}
                                    
                                    { (!STOCKS || !STOCKS[this.state.stockList] || Object.keys(STOCKS[this.state.stockList]).length === 0)  && 
                                    <TableRow>
                                        <td colSpan="4">
                                        <div className="text-center">
                                            <h5>Pas de Stock</h5> 
                                        </div>
                                    </td>
                                    </TableRow>
                                    }
                                </TableBody>
                            </ListLayout>
                            
                            {/* Pagination */}
                            {STOCKS && STOCKS[this.state.stockList] && Object.keys(STOCKS[this.state.stockList]).length > 0 && (
                                <TablePagination
                                    component="div"
                                    count={this.getTotalCount()}
                                    page={this.getValidPage()}
                                    onPageChange={this.handleChangePage}
                                    rowsPerPage={this.state.rowsPerPage}
                                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                    labelRowsPerPage="Lignes par page:"
                                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} sur ${count}`}
                                />
                            )}
                        </Card>
                    </Box>
                }
            </div>
        );
    }
}
function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        PRODUCTS: state.inventory.products,
        SHOPS: state.inventory.shops,
        STOCKS: state.inventory.stocks,
        SALES: state.inventory.sales.ALL,
        PURCHASES: state.inventory.purchases.ALL,
        CLIENTS: state.inventory.clients,
        RETURNS: state.inventory.returns,
        AGENTS: state.agents.agents,
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        fetchStocks
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps )(StockList);